import NoDataFoundComponent from "@/app/components/ui/NoRecordFound";
import TableSkeleton from "@/app/components/ui/Skeletons/TableSkeleton";
import { useImageConstants } from "@/app/hooks/useImageConstants";
import { useLoader } from "@/app/hooks/useLoader";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { useUtils } from "@/app/hooks/useUtils";
import { IRotaState } from "@/app_redux/reducers/slices/auth/rota_slice";
import { useRef, useState } from "react";
import { Tooltip } from "react-tooltip";
import FilterComponent from "../FilterComponent";
import ShiftAddModalComponent from "../Modals/ShiftAddModalComponent";
import ShiftEditDeleteModalComponent from "../Modals/ShiftEditDeleteModalComponent";

export default function RotaCalenderComponent() {
  const container = useRef(null);
  const { NO_PWL_RESULTS } = useImageConstants();
  const containerNav = useRef(null);
  const isRotaLoading = useLoader("isClinicWiseRotaListInProgress");
  const [cityNameSelection, setCityNameSelection] = useState("Gurugram");

  const [copyActive, setCopyActive] = useState(false);
  const [selectedClinics, setSelectedClinics] = useState([]);
  const [dateRange, setDateRange] = useState([]);

  const { truncateString } = useUtils();
  const { getRouteKey } = useRouter();
  const routeId = getRouteKey("ROTA", "id");

  const { routeState } = useRouteInfo(routeId);
  const { filterData } = routeState.state as IRotaState;

  const toggleClinicSelection = (clinicId, staffId) => {
    const clinicIndex = selectedClinics.findIndex((clinic) => clinic.clinic_id === clinicId);

    if (clinicIndex !== -1) {
      const updatedClinics = [...selectedClinics];
      const staffIndex = updatedClinics[clinicIndex].staff_ids.indexOf(staffId);

      if (staffIndex !== -1) {
        // If staffId is already selected, remove it
        updatedClinics[clinicIndex].staff_ids.splice(staffIndex, 1);
      } else {
        // If staffId is not selected, add it
        updatedClinics[clinicIndex].staff_ids.push(staffId);
      }

      setSelectedClinics(updatedClinics);
    } else {
      // If the clinic is not selected, create a new entry
      setSelectedClinics((prevClinics) => [
        ...prevClinics,
        {
          clinic_id: clinicId,
          staff_ids: [staffId],
        },
      ]);
    }
  };

  const toggleAllStaff = (clinicId, staffIds) => {
    const clinicIndex = selectedClinics.findIndex((clinic) => clinic.clinic_id === clinicId);

    if (clinicIndex !== -1) {
      const updatedClinics = [...selectedClinics];
      const staffIdsForClinic = updatedClinics[clinicIndex].staff_ids;

      if (staffIdsForClinic.length === staffIds.length) {
        updatedClinics.splice(clinicIndex, 1);
      } else {
        updatedClinics[clinicIndex].staff_ids = staffIds;
      }

      setSelectedClinics(updatedClinics);
    } else {
      setSelectedClinics((prevClinics) => [
        ...prevClinics,
        {
          clinic_id: clinicId,
          staff_ids: staffIds,
        },
      ]);
    }
  };

  const processDataForWeek = (week, data) => {
    if (data) {
      const processedData = week.map((day) => {
        const rotaData = data.find((item) => item.rota_date === day.id);

        if (rotaData) {
          return {
            title: day.title,
            content: rotaData,
            flage: true,
          };
        } else {
          return {
            title: day.title,
            content: "+",
            flage: false,
          };
        }
      });

      return processedData;
    } else {
      const placeholderData = week.map((day) => ({
        title: day.id,
        content: "+",
        flage: false,
      }));
      return placeholderData;
    }
  };

  return (
    <div className="bg-white py-3 px-3 rounded-md">
      <div className="sticky top-14 z-30 bg-white">
        <FilterComponent
          copyActive={copyActive}
          setCopyActive={setCopyActive}
          selectedClinics={selectedClinics}
          setDateRange={setDateRange}
          dateRange={dateRange}
          setCityNameSelection={setCityNameSelection}
          setSelectedClinics={setSelectedClinics}
        />

        <div ref={containerNav} className="   flex-none bg-white   ring-black ring-opacity-5 ">
          <div className=" border border-slate-100  hidden grid-cols-8 divide-x divide-gray-100 text-sm leading-6 text-gray-500 sm:grid">
            <div className="flex items-center  py-3 pl-2 gap-2 ">
              <span className="text-black text-base font-medium text-left">{cityNameSelection}</span>
            </div>

            {dateRange?.map((value, id) => {
              return (
                <div key={id} className="flex flex-col items-start justify-center p-3 ">
                  <span className="text-[#808DA0] text-xs font-semibold uppercase "> {value?.title}</span>
                  <span className="  font-semibold text-black text-lg">{value?.id?.split("-")[2]}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {!isRotaLoading ? (
        <div ref={container} className="isolate flex flex-auto flex-col overflow-auto bg-white">
          {filterData?.length > 0 ? (
            <div style={{ width: "165%" }} className="   max-w-full flex-none  sm:max-w-none md:max-w-full">
              <div>
                <div className=" h-auto flex flex-col">
                  {filterData?.map((value, id) => (
                    <div key={id}>
                      <div className="bg-[#E2EEFF] border-b border-b-slate-100  p-2 col-span-3 md:col-span-5 lg:col-span-8">
                        <div className="flex gap-2">
                          {copyActive && (
                            <input
                              type="checkbox"
                              onChange={() =>
                                toggleAllStaff(
                                  value?.clinic_id,
                                  value?.staff_details.map((doctor) => doctor.staff_id),
                                )
                              }
                              className="h-4 w-4 rounded-sm border-gray-300 text-black focus:ring-0"
                            />
                          )}
                          <p className="text-sm text-black font-medium ">{value?.clinic_name}</p>
                        </div>
                      </div>
                      <div className="w-full grid grid-cols-1">
                        {value?.staff_details?.map((doctor, idx) => (
                          <div key={idx} className="items-center w-full grid grid-cols-8">
                            <div className="flex items-left py-3 gap-2  border border-slate-100 h-16  items-center">
                              <div className="felx gap-2 pl-1">
                                {copyActive && (
                                  <input
                                    type="checkbox"
                                    checked={selectedClinics.some(
                                      (clinic) =>
                                        clinic.clinic_id === value?.clinic_id &&
                                        clinic.staff_ids.includes(doctor.staff_id),
                                    )}
                                    className="h-4 w-4 rounded-sm border-gray-300 text-black focus:ring-0"
                                    onChange={() => toggleClinicSelection(value?.clinic_id, doctor.staff_id)}
                                  />
                                )}
                              </div>
                              <div className="flex flex-col">
                                <span
                                  className="text-black text-sm text-left"
                                  data-tooltip-id="doctorName"
                                  data-tooltip-content={doctor?.staff_name}
                                >
                                  {/* {truncateString(doctor?.staff_name, 15)} */}
                                  {doctor?.staff_name}
                                </span>
                                <span className="text-[#808DA0] font-medium text-xs">
                                  {doctor?.staff_category_name}
                                </span>
                              </div>
                            </div>

                            {processDataForWeek(dateRange, doctor.rota_details)?.map((item, shiftId) => (
                              <div key={shiftId} className=" items-center">
                                <p>{item?.flage}</p>
                                <div>
                                  {item?.flage ? (
                                    <ShiftEditDeleteModalComponent
                                      flage={true}
                                      shellDetails={item?.content}
                                      clinicId={value}
                                      stafDetails={doctor}
                                      dateRange={dateRange}
                                    />
                                  ) : (
                                    <ShiftAddModalComponent
                                      flage={false}
                                      shellDetails={item?.title}
                                      clinicId={value}
                                      stafDetails={doctor}
                                      dateRange={dateRange}
                                    />
                                  )}
                                </div>
                              </div>
                            ))}
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <Tooltip id="doctorName" />
            </div>
          ) : (
            <NoDataFoundComponent
              imageURL={NO_PWL_RESULTS}
              message="No Rota For This Providers"
              description="No Rota found for the given filters, try something else"
            />
          )}
        </div>
      ) : (
        <TableSkeleton />
      )}
    </div>
  );
}
